import type { Goal } from "instantdb/types";

export const MOOD_GOALS: Partial<Goal>[] = [
  {
    id: "cultivate-daily-happiness",
    symbol: "😊",
    title: "Cultivate Daily Happiness",
    description: "Build small daily habits to boost your mood and emotional wellbeing",
  },
  {
    id: "develop-emotional-resilience",
    symbol: "🧘",
    title: "Develop Emotional Resilience",
    description: "Learn techniques to manage emotions and bounce back from challenges",
  },
  {
    id: "understand-your-mood-patterns",
    symbol: "🔍",
    title: "Understand Your Mood Patterns",
    description: "Track and identify factors that influence your emotional state",
  },
  {
    id: "strengthen-social-connections",
    symbol: "🤝",
    title: "Strengthen Social Connections",
    description: "Nurture relationships that contribute to your happiness and wellbeing",
  },
];
